// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RadioGroup-module__font-s-10___ChsBb {
  font-size: 10px !important;
}

.RadioGroup-module__font-s-12___yOzkA {
  font-size: 12px !important;
}

.RadioGroup-module__font-s-13___ArF2u {
  font-size: 13px !important;
}

.RadioGroup-module__font-s-14___IhB5J {
  font-size: 14px !important;
}

.RadioGroup-module__font-s-15___qtWFu {
  font-size: 15px !important;
}

.RadioGroup-module__font-s-16___fAsxM {
  font-size: 16px !important;
}

.RadioGroup-module__font-s-18___GhNWX {
  font-size: 18px !important;
}

.RadioGroup-module__font-s-20___TceP0 {
  font-size: 20px !important;
}

.RadioGroup-module__font-s-22___s9KUX {
  font-size: 22px !important;
}

.RadioGroup-module__font-s-28___hA3TG {
  font-size: 28px !important;
}

.RadioGroup-module__font-w-400___cqvch {
  font-weight: 400 !important;
}

.RadioGroup-module__font-w-500___d_eJr {
  font-weight: 500 !important;
}

.RadioGroup-module__font-w-600___zOKW6 {
  font-weight: 600 !important;
}

.RadioGroup-module__font-w-700___scZAZ {
  font-weight: 700 !important;
}

.RadioGroup-module__p-5___tlk1M {
  padding: 5px !important;
}

.RadioGroup-module__p-12___FLrLz {
  padding: 12px !important;
}

.RadioGroup-module__p-16___eNEJL {
  padding: 16px !important;
}

.RadioGroup-module__p-30___Flfxk {
  padding: 30px !important;
}

.RadioGroup-module__p-b-0___T_mzL {
  padding-bottom: 0 !important;
}

.RadioGroup-module__p-b-5___IzdHj {
  padding-bottom: 5px !important;
}

.RadioGroup-module__p-b-10___TEOPa {
  padding-bottom: 10px !important;
}

.RadioGroup-module__p-b-12___X6jVM {
  padding-bottom: 12px !important;
}

.RadioGroup-module__p-b-16___cGfUu {
  padding-bottom: 16px !important;
}

.RadioGroup-module__p-b-18___Q235G {
  padding-bottom: 18px !important;
}

.RadioGroup-module__p-b-20___zmviV {
  padding-bottom: 20px !important;
}

.RadioGroup-module__p-b-25___nC2t1 {
  padding-bottom: 25px !important;
}

.RadioGroup-module__p-b-30___GpwxG {
  padding-bottom: 30px !important;
}

.RadioGroup-module__p-b-50___z6vrR {
  padding-bottom: 50px !important;
}

.RadioGroup-module__p-t-0___TdqTc {
  padding-top: 0 !important;
}

.RadioGroup-module__p-t-12___COayK {
  padding-top: 12px !important;
}

.RadioGroup-module__p-t-16___Ba5nP {
  padding-top: 16px !important;
}

.RadioGroup-module__p-t-18____UEIo {
  padding-top: 18px !important;
}

.RadioGroup-module__p-t-20___WspVb {
  padding-top: 20px !important;
}

.RadioGroup-module__p-t-30___pjRXu {
  padding-top: 30px !important;
}

.RadioGroup-module__p-t-40___Gyw1r {
  padding-top: 40px !important;
}

.RadioGroup-module__p-t-50___gy3K8 {
  padding-top: 50px !important;
}

.RadioGroup-module__p-l-20___Vb4yQ {
  padding-left: 20px !important;
}

.RadioGroup-module__p-l-30___EKEn_ {
  padding-left: 30px !important;
}

.RadioGroup-module__p-l-40___JnX5p {
  padding-left: 40px !important;
}

.RadioGroup-module__p-r-16___SibKY {
  padding-right: 16px !important;
}

.RadioGroup-module__p-r-20___clQQw {
  padding-right: 20px !important;
}

.RadioGroup-module__p-r-30___fHH76 {
  padding-right: 30px !important;
}

.RadioGroup-module__p-r-50___iQmKV {
  padding-right: 50px !important;
}

.RadioGroup-module__p-r-60___bF84c {
  padding-right: 60px !important;
}

.RadioGroup-module__m-b-1___ZoBP6 {
  margin-bottom: 1px !important;
}

.RadioGroup-module__m-b-2___vxc3S {
  margin-bottom: 2px !important;
}

.RadioGroup-module__m-b-6___dSNZK {
  margin-bottom: 6px !important;
}

.RadioGroup-module__m-b-8___TaYLm {
  margin-bottom: 8px !important;
}

.RadioGroup-module__m-b-10___KJx50 {
  margin-bottom: 10px !important;
}

.RadioGroup-module__m-b-14___Z3cYd {
  margin-bottom: 14px !important;
}

.RadioGroup-module__m-b-16___iAivD {
  margin-bottom: 16px !important;
}

.RadioGroup-module__m-b-20___UiOBB {
  margin-bottom: 20px !important;
}

.RadioGroup-module__m-b-22___dMM0p {
  margin-bottom: 22px !important;
}

.RadioGroup-module__m-b-24___hriFZ {
  margin-bottom: 24px !important;
}

.RadioGroup-module__m-b-30___BG9d9 {
  margin-bottom: 30px !important;
}

.RadioGroup-module__m-b-32___l5P8e {
  margin-bottom: 32px !important;
}

.RadioGroup-module__m-b-40___O8Cw4 {
  margin-bottom: 40px !important;
}

.RadioGroup-module__m-t-2___IgrRy {
  margin-top: 2px !important;
}

.RadioGroup-module__m-t-3___Vuh6F {
  margin-top: 3px !important;
}

.RadioGroup-module__m-t-4___C7e1V {
  margin-top: 4px !important;
}

.RadioGroup-module__m-t-5___pqYDI {
  margin-top: 5px !important;
}

.RadioGroup-module__m-t-8___DIbMU {
  margin-top: 8px !important;
}

.RadioGroup-module__m-t-10___aeyYJ {
  margin-top: 10px !important;
}

.RadioGroup-module__m-t-15___zzWD0 {
  margin-top: 15px !important;
}

.RadioGroup-module__m-t-16____kaGk {
  margin-top: 16px !important;
}

.RadioGroup-module__m-t-20___XMG8S {
  margin-top: 20px !important;
}

.RadioGroup-module__m-t-22___KZO7q {
  margin-top: 22px !important;
}

.RadioGroup-module__m-t-30___tLgWu {
  margin-top: 30px !important;
}

.RadioGroup-module__m-t-32___rBzq3 {
  margin-top: 32px !important;
}

.RadioGroup-module__m-l-auto___O3SEU {
  margin-left: auto !important;
}

.RadioGroup-module__m-l-4___Nf7q8 {
  margin-left: 4px !important;
}

.RadioGroup-module__m-l-5___Fokl2 {
  margin-left: 5px !important;
}

.RadioGroup-module__m-l-6___LhuuF {
  margin-left: 6px !important;
}

.RadioGroup-module__m-l-8___Fe32y {
  margin-left: 8px !important;
}

.RadioGroup-module__m-l-10___ERsrF {
  margin-left: 10px !important;
}

.RadioGroup-module__m-l-16___y7Aaq {
  margin-left: 16px !important;
}

.RadioGroup-module__m-l-20___hwOpU {
  margin-left: 20px !important;
}

.RadioGroup-module__m-l-24___zqUy0 {
  margin-left: 24px !important;
}

.RadioGroup-module__m-l-30___i5NXq {
  margin-left: 30px !important;
}

.RadioGroup-module__m-l-35___ykTz6 {
  margin-left: 35px !important;
}

.RadioGroup-module__m-l-40___GxLNi {
  margin-left: 40px !important;
}

.RadioGroup-module__m-r-8___lzmdQ {
  margin-right: 8px !important;
}

.RadioGroup-module__m-r-10___QO4dv {
  margin-right: 10px !important;
}

.RadioGroup-module__m-r-16___jAF1m {
  margin-right: 16px !important;
}

.RadioGroup-module__m-r-20___uIHG2 {
  margin-right: 20px !important;
}

.RadioGroup-module__m-r-24___pSlBT {
  margin-right: 24px !important;
}

.RadioGroup-module__m-r-30___syhM1 {
  margin-right: 30px !important;
}

.RadioGroup-module__m-r-40___OPRVP {
  margin-right: 40px !important;
}

.RadioGroup-module__border-r-3___zov2z {
  border-radius: 3px !important;
}

.RadioGroup-module__border-r-4___k34EH {
  border-radius: 4px !important;
}

.RadioGroup-module__border-r-6___MGAbY {
  border-radius: 6px !important;
}

.RadioGroup-module__border-r-10___ly3Wb {
  border-radius: 10px !important;
}

.RadioGroup-module__border-r-12___lFhrs {
  border-radius: 12px !important;
}

.RadioGroup-module__border-r-16___B69b7 {
  border-radius: 16px !important;
}

.RadioGroup-module__border-r-50___dy1V4 {
  border-radius: 50% !important;
}

.RadioGroup-module__primary-border___jCN8u {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.RadioGroup-module__primary-border-b___z20Ko {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.RadioGroup-module__primary-border-t___pZoM6 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.RadioGroup-module__primary-border-l___gIEna {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.RadioGroup-module__primary-border-r___AMdOl {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.RadioGroup-module__secondary-border___Jm3Yf {
  border: 1px solid #637768;
}

.RadioGroup-module__secondary-border-b___cyN_k {
  border-bottom: 1px solid #637768;
}

.RadioGroup-module__secondary-border-t___lkZ3u {
  border-top: 1px solid #637768;
}

.RadioGroup-module__secondary-border-l___aJU55 {
  border-left: 1px solid #637768;
}

.RadioGroup-module__secondary-border-r___cTMu5 {
  border-right: 1px solid #637768;
}

.RadioGroup-module__gap-0___pvpTm {
  gap: 0 !important;
}

.RadioGroup-module__gap-2___pw1ds {
  gap: 2px !important;
}

.RadioGroup-module__gap-4___RH0tB {
  gap: 4px !important;
}

.RadioGroup-module__gap-5___LUGaj {
  gap: 5px !important;
}

.RadioGroup-module__gap-6___T9SOZ {
  gap: 6px !important;
}

.RadioGroup-module__gap-8___vHR4O {
  gap: 8px !important;
}

.RadioGroup-module__gap-10___ffc8L {
  gap: 10px !important;
}

.RadioGroup-module__gap-12___LonWq {
  gap: 12px !important;
}

.RadioGroup-module__gap-14___AEd53 {
  gap: 14px !important;
}

.RadioGroup-module__gap-16___XjN_M {
  gap: 16px !important;
}

.RadioGroup-module__gap-18___ew9Aq {
  gap: 18px !important;
}

.RadioGroup-module__gap-20___uEsRi {
  gap: 20px !important;
}

.RadioGroup-module__gap-24___rmrTv {
  gap: 24px !important;
}

.RadioGroup-module__gap-26___KIKDI {
  gap: 26px !important;
}

.RadioGroup-module__gap-30____Ko6X {
  gap: 30px !important;
}

.RadioGroup-module__gap-32___QIkic {
  gap: 32px !important;
}

.RadioGroup-module__gap-40___GFMIT {
  gap: 40px !important;
}

.RadioGroup-module__gap-50___M_Yme {
  gap: 50px !important;
}

.RadioGroup-module__flex-1___LuLO4 {
  flex: 1;
}

.RadioGroup-module__flex-none___Q02iY {
  flex: none !important;
}

.RadioGroup-module__flex-column___X_Up8 {
  display: flex;
  flex-direction: column !important;
}

.RadioGroup-module__flex-row___sUKVI {
  display: flex;
  flex-direction: row !important;
}

.RadioGroup-module__vertically-centered___bxR9K {
  display: flex;
  align-items: center !important;
}

.RadioGroup-module__horizontally-centered___pNRwk {
  display: flex;
  justify-content: center !important;
}

.RadioGroup-module__horizontally-end___tXtwN {
  display: flex;
  justify-content: end !important;
}

.RadioGroup-module__vertically-start___T_jf_ {
  display: flex;
  align-items: start !important;
}

.RadioGroup-module__space-between___J3pXh {
  display: flex;
  justify-content: space-between !important;
}

.RadioGroup-module__flex-wrap___B5Czl {
  flex-wrap: wrap !important;
}

.RadioGroup-module__height-100___ZYnX1 {
  height: 100%;
}

.RadioGroup-module__width-50___D4tD0 {
  width: 50% !important;
}

.RadioGroup-module__width-100___Sic8V {
  width: 100%;
}

.RadioGroup-module__cursor-pointer___TDsTH {
  cursor: pointer;
}

.RadioGroup-module__cursor-not-allowed___wjb82 {
  cursor: not-allowed !important;
}

.RadioGroup-module__absolute-centered___M6wfA {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.RadioGroup-module__absolute___G3ajV {
  position: absolute;
}

.RadioGroup-module__relative___YH0OD {
  position: relative;
}

.RadioGroup-module__fixed___imYW4 {
  position: fixed;
}

.RadioGroup-module__visible___gd_E_ {
  opacity: 1;
}

.RadioGroup-module__invisible___jZIOI {
  opacity: 0;
}

.RadioGroup-module__col-90___VYLI1 {
  width: 90% !important;
}

.RadioGroup-module__col-auto___F9BOA {
  width: auto !important;
}

.RadioGroup-module__medical-tabs___dNqib {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.RadioGroup-module__medical-table-new___dpm_J {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.RadioGroup-module__medical-table-new___dpm_J:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.RadioGroup-module__medical-table-new___dpm_J::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.RadioGroup-module__medical-table-new___dpm_J::-webkit-scrollbar-track {
  display: none;
}
.RadioGroup-module__medical-table-new___dpm_J.RadioGroup-module__no-pagination___UDQS_ {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.RadioGroup-module__medical-table-new___dpm_J.RadioGroup-module__no-pagination___UDQS_:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.RadioGroup-module__medical-table-new___dpm_J.RadioGroup-module__no-pagination___UDQS_::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.RadioGroup-module__medical-table-new___dpm_J.RadioGroup-module__no-pagination___UDQS_::-webkit-scrollbar-track {
  display: none;
}

.RadioGroup-module__medical-table-empty___UB7aJ {
  padding: 14px 40px !important;
}

.RadioGroup-module__icon-btn___mqx_c {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.RadioGroup-module__search-icon___uATRM {
  width: 24px;
  height: 24px;
  align-self: center;
}

.RadioGroup-module__disable-select___bLLvq {
  user-select: none;
}

.RadioGroup-module__break-word___RRy0z {
  word-break: break-word;
}

.RadioGroup-module__popup-clear-btn___e73wM {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.RadioGroup-module__scroll-m-b-20___PNkPs {
  scroll-margin-bottom: 20px;
}

.RadioGroup-module__description___we9yB {
  color: #375844;
  display: block;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./../common/src/components/base/RadioGroup/RadioGroup.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;EACA,cAAA;AA8pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.description {\n  color: get-color(greenNew, dark);\n  display: block;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `RadioGroup-module__font-s-10___ChsBb`,
	"fontS12": `RadioGroup-module__font-s-12___yOzkA`,
	"fontS13": `RadioGroup-module__font-s-13___ArF2u`,
	"fontS14": `RadioGroup-module__font-s-14___IhB5J`,
	"fontS15": `RadioGroup-module__font-s-15___qtWFu`,
	"fontS16": `RadioGroup-module__font-s-16___fAsxM`,
	"fontS18": `RadioGroup-module__font-s-18___GhNWX`,
	"fontS20": `RadioGroup-module__font-s-20___TceP0`,
	"fontS22": `RadioGroup-module__font-s-22___s9KUX`,
	"fontS28": `RadioGroup-module__font-s-28___hA3TG`,
	"fontW400": `RadioGroup-module__font-w-400___cqvch`,
	"fontW500": `RadioGroup-module__font-w-500___d_eJr`,
	"fontW600": `RadioGroup-module__font-w-600___zOKW6`,
	"fontW700": `RadioGroup-module__font-w-700___scZAZ`,
	"p5": `RadioGroup-module__p-5___tlk1M`,
	"p12": `RadioGroup-module__p-12___FLrLz`,
	"p16": `RadioGroup-module__p-16___eNEJL`,
	"p30": `RadioGroup-module__p-30___Flfxk`,
	"pB0": `RadioGroup-module__p-b-0___T_mzL`,
	"pB5": `RadioGroup-module__p-b-5___IzdHj`,
	"pB10": `RadioGroup-module__p-b-10___TEOPa`,
	"pB12": `RadioGroup-module__p-b-12___X6jVM`,
	"pB16": `RadioGroup-module__p-b-16___cGfUu`,
	"pB18": `RadioGroup-module__p-b-18___Q235G`,
	"pB20": `RadioGroup-module__p-b-20___zmviV`,
	"pB25": `RadioGroup-module__p-b-25___nC2t1`,
	"pB30": `RadioGroup-module__p-b-30___GpwxG`,
	"pB50": `RadioGroup-module__p-b-50___z6vrR`,
	"pT0": `RadioGroup-module__p-t-0___TdqTc`,
	"pT12": `RadioGroup-module__p-t-12___COayK`,
	"pT16": `RadioGroup-module__p-t-16___Ba5nP`,
	"pT18": `RadioGroup-module__p-t-18____UEIo`,
	"pT20": `RadioGroup-module__p-t-20___WspVb`,
	"pT30": `RadioGroup-module__p-t-30___pjRXu`,
	"pT40": `RadioGroup-module__p-t-40___Gyw1r`,
	"pT50": `RadioGroup-module__p-t-50___gy3K8`,
	"pL20": `RadioGroup-module__p-l-20___Vb4yQ`,
	"pL30": `RadioGroup-module__p-l-30___EKEn_`,
	"pL40": `RadioGroup-module__p-l-40___JnX5p`,
	"pR16": `RadioGroup-module__p-r-16___SibKY`,
	"pR20": `RadioGroup-module__p-r-20___clQQw`,
	"pR30": `RadioGroup-module__p-r-30___fHH76`,
	"pR50": `RadioGroup-module__p-r-50___iQmKV`,
	"pR60": `RadioGroup-module__p-r-60___bF84c`,
	"mB1": `RadioGroup-module__m-b-1___ZoBP6`,
	"mB2": `RadioGroup-module__m-b-2___vxc3S`,
	"mB6": `RadioGroup-module__m-b-6___dSNZK`,
	"mB8": `RadioGroup-module__m-b-8___TaYLm`,
	"mB10": `RadioGroup-module__m-b-10___KJx50`,
	"mB14": `RadioGroup-module__m-b-14___Z3cYd`,
	"mB16": `RadioGroup-module__m-b-16___iAivD`,
	"mB20": `RadioGroup-module__m-b-20___UiOBB`,
	"mB22": `RadioGroup-module__m-b-22___dMM0p`,
	"mB24": `RadioGroup-module__m-b-24___hriFZ`,
	"mB30": `RadioGroup-module__m-b-30___BG9d9`,
	"mB32": `RadioGroup-module__m-b-32___l5P8e`,
	"mB40": `RadioGroup-module__m-b-40___O8Cw4`,
	"mT2": `RadioGroup-module__m-t-2___IgrRy`,
	"mT3": `RadioGroup-module__m-t-3___Vuh6F`,
	"mT4": `RadioGroup-module__m-t-4___C7e1V`,
	"mT5": `RadioGroup-module__m-t-5___pqYDI`,
	"mT8": `RadioGroup-module__m-t-8___DIbMU`,
	"mT10": `RadioGroup-module__m-t-10___aeyYJ`,
	"mT15": `RadioGroup-module__m-t-15___zzWD0`,
	"mT16": `RadioGroup-module__m-t-16____kaGk`,
	"mT20": `RadioGroup-module__m-t-20___XMG8S`,
	"mT22": `RadioGroup-module__m-t-22___KZO7q`,
	"mT30": `RadioGroup-module__m-t-30___tLgWu`,
	"mT32": `RadioGroup-module__m-t-32___rBzq3`,
	"mLAuto": `RadioGroup-module__m-l-auto___O3SEU`,
	"mL4": `RadioGroup-module__m-l-4___Nf7q8`,
	"mL5": `RadioGroup-module__m-l-5___Fokl2`,
	"mL6": `RadioGroup-module__m-l-6___LhuuF`,
	"mL8": `RadioGroup-module__m-l-8___Fe32y`,
	"mL10": `RadioGroup-module__m-l-10___ERsrF`,
	"mL16": `RadioGroup-module__m-l-16___y7Aaq`,
	"mL20": `RadioGroup-module__m-l-20___hwOpU`,
	"mL24": `RadioGroup-module__m-l-24___zqUy0`,
	"mL30": `RadioGroup-module__m-l-30___i5NXq`,
	"mL35": `RadioGroup-module__m-l-35___ykTz6`,
	"mL40": `RadioGroup-module__m-l-40___GxLNi`,
	"mR8": `RadioGroup-module__m-r-8___lzmdQ`,
	"mR10": `RadioGroup-module__m-r-10___QO4dv`,
	"mR16": `RadioGroup-module__m-r-16___jAF1m`,
	"mR20": `RadioGroup-module__m-r-20___uIHG2`,
	"mR24": `RadioGroup-module__m-r-24___pSlBT`,
	"mR30": `RadioGroup-module__m-r-30___syhM1`,
	"mR40": `RadioGroup-module__m-r-40___OPRVP`,
	"borderR3": `RadioGroup-module__border-r-3___zov2z`,
	"borderR4": `RadioGroup-module__border-r-4___k34EH`,
	"borderR6": `RadioGroup-module__border-r-6___MGAbY`,
	"borderR10": `RadioGroup-module__border-r-10___ly3Wb`,
	"borderR12": `RadioGroup-module__border-r-12___lFhrs`,
	"borderR16": `RadioGroup-module__border-r-16___B69b7`,
	"borderR50": `RadioGroup-module__border-r-50___dy1V4`,
	"primaryBorder": `RadioGroup-module__primary-border___jCN8u`,
	"primaryBorderB": `RadioGroup-module__primary-border-b___z20Ko`,
	"primaryBorderT": `RadioGroup-module__primary-border-t___pZoM6`,
	"primaryBorderL": `RadioGroup-module__primary-border-l___gIEna`,
	"primaryBorderR": `RadioGroup-module__primary-border-r___AMdOl`,
	"secondaryBorder": `RadioGroup-module__secondary-border___Jm3Yf`,
	"secondaryBorderB": `RadioGroup-module__secondary-border-b___cyN_k`,
	"secondaryBorderT": `RadioGroup-module__secondary-border-t___lkZ3u`,
	"secondaryBorderL": `RadioGroup-module__secondary-border-l___aJU55`,
	"secondaryBorderR": `RadioGroup-module__secondary-border-r___cTMu5`,
	"gap0": `RadioGroup-module__gap-0___pvpTm`,
	"gap2": `RadioGroup-module__gap-2___pw1ds`,
	"gap4": `RadioGroup-module__gap-4___RH0tB`,
	"gap5": `RadioGroup-module__gap-5___LUGaj`,
	"gap6": `RadioGroup-module__gap-6___T9SOZ`,
	"gap8": `RadioGroup-module__gap-8___vHR4O`,
	"gap10": `RadioGroup-module__gap-10___ffc8L`,
	"gap12": `RadioGroup-module__gap-12___LonWq`,
	"gap14": `RadioGroup-module__gap-14___AEd53`,
	"gap16": `RadioGroup-module__gap-16___XjN_M`,
	"gap18": `RadioGroup-module__gap-18___ew9Aq`,
	"gap20": `RadioGroup-module__gap-20___uEsRi`,
	"gap24": `RadioGroup-module__gap-24___rmrTv`,
	"gap26": `RadioGroup-module__gap-26___KIKDI`,
	"gap30": `RadioGroup-module__gap-30____Ko6X`,
	"gap32": `RadioGroup-module__gap-32___QIkic`,
	"gap40": `RadioGroup-module__gap-40___GFMIT`,
	"gap50": `RadioGroup-module__gap-50___M_Yme`,
	"flex1": `RadioGroup-module__flex-1___LuLO4`,
	"flexNone": `RadioGroup-module__flex-none___Q02iY`,
	"flexColumn": `RadioGroup-module__flex-column___X_Up8`,
	"flexRow": `RadioGroup-module__flex-row___sUKVI`,
	"verticallyCentered": `RadioGroup-module__vertically-centered___bxR9K`,
	"horizontallyCentered": `RadioGroup-module__horizontally-centered___pNRwk`,
	"horizontallyEnd": `RadioGroup-module__horizontally-end___tXtwN`,
	"verticallyStart": `RadioGroup-module__vertically-start___T_jf_`,
	"spaceBetween": `RadioGroup-module__space-between___J3pXh`,
	"flexWrap": `RadioGroup-module__flex-wrap___B5Czl`,
	"height100": `RadioGroup-module__height-100___ZYnX1`,
	"width50": `RadioGroup-module__width-50___D4tD0`,
	"width100": `RadioGroup-module__width-100___Sic8V`,
	"cursorPointer": `RadioGroup-module__cursor-pointer___TDsTH`,
	"cursorNotAllowed": `RadioGroup-module__cursor-not-allowed___wjb82`,
	"absoluteCentered": `RadioGroup-module__absolute-centered___M6wfA`,
	"absolute": `RadioGroup-module__absolute___G3ajV`,
	"relative": `RadioGroup-module__relative___YH0OD`,
	"fixed": `RadioGroup-module__fixed___imYW4`,
	"visible": `RadioGroup-module__visible___gd_E_`,
	"invisible": `RadioGroup-module__invisible___jZIOI`,
	"col90": `RadioGroup-module__col-90___VYLI1`,
	"colAuto": `RadioGroup-module__col-auto___F9BOA`,
	"medicalTabs": `RadioGroup-module__medical-tabs___dNqib`,
	"medicalTableNew": `RadioGroup-module__medical-table-new___dpm_J`,
	"noPagination": `RadioGroup-module__no-pagination___UDQS_`,
	"medicalTableEmpty": `RadioGroup-module__medical-table-empty___UB7aJ`,
	"iconBtn": `RadioGroup-module__icon-btn___mqx_c`,
	"searchIcon": `RadioGroup-module__search-icon___uATRM`,
	"disableSelect": `RadioGroup-module__disable-select___bLLvq`,
	"breakWord": `RadioGroup-module__break-word___RRy0z`,
	"popupClearBtn": `RadioGroup-module__popup-clear-btn___e73wM`,
	"scrollMB20": `RadioGroup-module__scroll-m-b-20___PNkPs`,
	"description": `RadioGroup-module__description___we9yB`
};
module.exports = ___CSS_LOADER_EXPORT___;
